<template>
    <div>
        <div></div>
        <v-card flat>
            <v-card-text>
                This is a flexible/reusable confirmation dialog.<br/>
                It's set up so that it will be available to us on every page.</br>
                Typically, you'll invoke it using <code>refs</code> that are defined on the <code>$root</code> Vue component.
                Pressing the button below should invoke it, and log a message to the console only if the user affirmatively dismisses it.
            </v-card-text>
            <v-card-actions>
                <v-btn @click="doSomething">
                    Open Confirmation Dialog
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "ExampleConfirmDialog",
    components: {
        AppLayout,
        SmartTable
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            examplefile: this.input,
        }
    },
    methods: {
        async doSomething() {
            let title = `Testing Confirmation Dialog`
            let message = `If you hit OK, a message will be logged to the JS console`
            if (await this.$root.confirm.open(title, message)) {
                console.log("You hit OK")
            }
        },
    },
}
</script>

<style>

</style>
